import { render, staticRenderFns } from "./CategorieCard.vue?vue&type=template&id=471889f6&scoped=true&"
import script from "./CategorieCard.vue?vue&type=script&lang=js&"
export * from "./CategorieCard.vue?vue&type=script&lang=js&"
import style0 from "./CategorieCard.vue?vue&type=style&index=0&id=471889f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471889f6",
  null
  
)

export default component.exports